export default __webpack_public_path__ + "static/media/mungin.70e873a2.svg";